import { observable, action } from "mobx";
import { BranchInfo } from "sb-resp-lib";

export type MultiViewBranchType = {
    leagueIds: string[];
    enetPulseID?: string;
    marketNames?: {};
    id: string;
    name: string;
    sortId: number;
    code: string;
}

export class MultiViewBranchInfo extends BranchInfo
{
    @observable leagueIds: string[];
    enetPulseID?: string;
    @observable marketNames?: {}

    constructor(branchData: MultiViewBranchType) {
        super(branchData);
        this.leagueIds = branchData.leagueIds;
        branchData.enetPulseID && (this.enetPulseID = branchData.enetPulseID);
        branchData.marketNames && (this.marketNames = branchData.marketNames);
    }

    @action.bound addLeagueId(id:string) {
        this.leagueIds.push(id);
    }
}